"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/product-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Fproduct-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.productStatusToJSON = exports.productStatusFromJSON = exports.ProductStatus = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.underwriting.common.proto';
/**
 * Status of a lending product
 */
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["INVALID_PRODUCT_STATUS"] = "INVALID_PRODUCT_STATUS";
    /**
     * PRODUCT_APPROVED - Product is approved.
     * Next step is usually to accept or reject it.
     */
    ProductStatus["PRODUCT_APPROVED"] = "PRODUCT_APPROVED";
    /**
     * PRODUCT_DECLINED - Product is not approved.
     */
    ProductStatus["PRODUCT_DECLINED"] = "PRODUCT_DECLINED";
    /**
     * USER_ACCEPTED - User accepted the the offer
     */
    ProductStatus["USER_ACCEPTED"] = "USER_ACCEPTED";
    /**
     * USER_REJECTED - User rejected the offer
     */
    ProductStatus["USER_REJECTED"] = "USER_REJECTED";
    ProductStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ProductStatus || (exports.ProductStatus = ProductStatus = {}));
function productStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PRODUCT_STATUS':
            return ProductStatus.INVALID_PRODUCT_STATUS;
        case 1:
        case 'PRODUCT_APPROVED':
            return ProductStatus.PRODUCT_APPROVED;
        case 2:
        case 'PRODUCT_DECLINED':
            return ProductStatus.PRODUCT_DECLINED;
        case 3:
        case 'USER_ACCEPTED':
            return ProductStatus.USER_ACCEPTED;
        case 4:
        case 'USER_REJECTED':
            return ProductStatus.USER_REJECTED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ProductStatus.UNRECOGNIZED;
    }
}
exports.productStatusFromJSON = productStatusFromJSON;
function productStatusToJSON(object) {
    switch (object) {
        case ProductStatus.INVALID_PRODUCT_STATUS:
            return 'INVALID_PRODUCT_STATUS';
        case ProductStatus.PRODUCT_APPROVED:
            return 'PRODUCT_APPROVED';
        case ProductStatus.PRODUCT_DECLINED:
            return 'PRODUCT_DECLINED';
        case ProductStatus.USER_ACCEPTED:
            return 'USER_ACCEPTED';
        case ProductStatus.USER_REJECTED:
            return 'USER_REJECTED';
        case ProductStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.productStatusToJSON = productStatusToJSON;
//# sourceMappingURL=product-status.js.map